import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Provider } from "react-redux";
import { SnackbarProvider, closeSnackbar } from "notistack";
import ConfigureStore from "./redux/store/ConfigureStore";
import reportWebVitals from "./reportWebVitals";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";

const store = ConfigureStore();

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <SnackbarProvider
            action={(snackbarId: string | number) => (
              <Button onClick={() => closeSnackbar(snackbarId)}>
                <CloseIcon style={{ color: "#fff" }} />
              </Button>
            )}
            maxSnack={4}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <App />
          </SnackbarProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
